import { render, staticRenderFns } from "./snap08.vue?vue&type=template&id=79af5eb8"
import script from "./snap08.vue?vue&type=script&lang=js"
export * from "./snap08.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports